import React, { useEffect } from "react";

import { FormField, FormSubscribe, InputNumeric, Text } from "@performyard/py-components";
import { Checkbox } from "@performyard/py-components/src/components/atoms/Checkbox";

import Spacer from "../../../../../../../components/Spacer";

import { useCompanySettings } from "../../../../../../../api/hooks";

export const FormBuilderNumericInput = ({
	value,
	onChange,
	precision,
	placeholder,
}: {
	value: number | null;
	onChange: (value: number | null) => void;
	precision: number;
	placeholder: string;
}) => {
	useEffect(() => {
		// parse the value to the correct precision
		if (value) {
			const parsedValue = parseFloat(value.toFixed(precision).toString());
			onChange(parsedValue);
		}
	}, [precision]);

	return (
		<InputNumeric
			value={value === undefined ? null : value}
			onChange={(value) => onChange(value)}
			precision={precision}
			allowEmpty
			placeholder={placeholder}
			parseOnBlur
		/>
	);
};

const NumericEdit = () => {
	const { data: settings } = useCompanySettings();
	const decimalPlaces = settings?.decimal_places || 0;

	return (
		<div>
			<div className="flex flex-col gap-2">
				<Text size="paragraph-3" weight="semi-bold">
					Numeric Range
				</Text>
				<FormField<boolean>
					id="decimals"
					label={<Text size="paragraph-3">Allow Decimals</Text>}
					labelPosition="right"
					input={(field) => (
						<div className="flex items-center gap-2">
							<Checkbox
								id="decimals"
								checked={field.value}
								onCheckedChange={() => field.onChange(!field.value)}
							/>
						</div>
					)}
				/>
			</div>
			<Spacer height={2} />
			<FormSubscribe id="decimals" selector={(state) => [state.values.decimals, state.values.max]}>
				{([decimals]) => (
					<FormField<number | null>
						id="min"
						validators={{
							onChangeListenTo: ["max"],
							onChange: ({ fieldApi }) => {
								fieldApi.state.meta.errors = [];
								fieldApi.state.meta.isTouched = true;
							},
						}}
						label={
							<div className="min-w-[50px]">
								<Text
									size="caption"
									weight="regular"
									dangerouslySetClassName="text-caption font-regular"
								>
									Minimum
								</Text>
							</div>
						}
						labelPosition="left"
						input={(field) => {
							return (
								<FormBuilderNumericInput
									value={field.value}
									onChange={field.onChange}
									precision={decimals ? decimalPlaces : 0}
									placeholder="Minimum Value"
								/>
							);
						}}
					/>
				)}
			</FormSubscribe>
			<Spacer height={1} />

			<FormSubscribe id="decimals" selector={(state) => [state.values.decimals, state.values.min]}>
				{([decimals]) => (
					<FormField<number | null>
						id="max"
						label={
							<div className="min-w-[50px]">
								<Text
									size="caption"
									weight="regular"
									dangerouslySetClassName="text-caption font-regular"
								>
									Maximum
								</Text>
							</div>
						}
						labelPosition="left"
						input={(field) => {
							return (
								<FormBuilderNumericInput
									value={field.value}
									onChange={field.onChange}
									precision={decimals ? decimalPlaces : 0}
									placeholder="Maximum Value"
								/>
							);
						}}
					/>
				)}
			</FormSubscribe>
		</div>
	);
};

export default NumericEdit;
